export const getWindowBounds = (win = window)=>{
    const viewport = win.visualViewport;
    return {
        width: viewport?.width !== undefined ? Math.min(win.innerWidth, viewport.width) : win.innerWidth,
        height: viewport?.height !== undefined ? Math.min(win.innerHeight, viewport.height) : win.innerHeight
    };
};

//# sourceMappingURL=getWindowBounds.js.map